import React, { useState, useEffect } from 'react';
import { adminAPI } from '../api';

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminAPI.dashboard().then(r => setStats(r.data.stats)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading"><div className="spinner" /> Loading dashboard...</div>;

  const cards = [
    { label: 'Total Users', value: stats?.total_users || 0, sub: `+${stats?.today_new_users || 0} today`, cls: 'stat-card-blue', icon: '👥' },
    { label: 'Active Investments', value: stats?.active_investments || 0, cls: 'stat-card-green', icon: '📈' },
    { label: 'Pending Deposits', value: stats?.pending_deposits?.total || 0, sub: `GHS ${parseFloat(stats?.pending_deposits?.sum || 0).toFixed(2)}`, cls: 'stat-card-gold', icon: '💳' },
    { label: 'Pending Withdrawals', value: stats?.pending_withdrawals?.total || 0, sub: `GHS ${parseFloat(stats?.pending_withdrawals?.sum || 0).toFixed(2)}`, cls: 'stat-card-red', icon: '💸' },
    { label: 'Total Deposited', value: `GHS ${parseFloat(stats?.total_deposited || 0).toFixed(2)}`, cls: 'stat-card-green', icon: '✅' },
    { label: 'Total Withdrawn', value: `GHS ${parseFloat(stats?.total_withdrawn || 0).toFixed(2)}`, cls: 'stat-card-blue', icon: '📤' },
  ];

  return (
    <div>
      <div className="stats-grid">
        {cards.map(c => (
          <div key={c.label} className={`stat-card ${c.cls}`}>
            <div className="stat-label">{c.icon} {c.label}</div>
            <div className="stat-value">{c.value}</div>
            {c.sub && <div className="stat-sub">{c.sub}</div>}
          </div>
        ))}
      </div>

      {/* Quick actions */}
      <div className="section-card">
        <h3>Quick Actions</h3>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <button className="btn btn-success" onClick={() => window.location.href = '/transactions?status=pending&type=deposit'}>✅ Approve Deposits ({stats?.pending_deposits?.total || 0})</button>
          <button className="btn btn-warning" onClick={() => window.location.href = '/transactions?status=pending&type=withdrawal'}>💸 Process Withdrawals ({stats?.pending_withdrawals?.total || 0})</button>
          <button className="btn btn-primary" onClick={() => window.location.href = '/users'}>👥 Manage Users</button>
          <button className="btn btn-gold" onClick={() => window.location.href = '/settings'}>⚙️ Site Settings</button>
        </div>
      </div>

      <div className="section-card">
        <h3>Platform Summary</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
          <div>
            <p style={{ fontSize: 13, color: 'var(--gray-400)', marginBottom: 4 }}>Total Deposited</p>
            <p style={{ fontSize: 22, fontWeight: 700, color: 'var(--success)' }}>GHS {parseFloat(stats?.total_deposited || 0).toLocaleString('en-GH', { minimumFractionDigits: 2 })}</p>
          </div>
          <div>
            <p style={{ fontSize: 13, color: 'var(--gray-400)', marginBottom: 4 }}>Total Withdrawn</p>
            <p style={{ fontSize: 22, fontWeight: 700, color: 'var(--danger)' }}>GHS {parseFloat(stats?.total_withdrawn || 0).toLocaleString('en-GH', { minimumFractionDigits: 2 })}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
